import kairos from './kairos';
import userManagement from './userManagement';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [kairos, userManagement]
};

export default menuItems;
